const LABELS: Record<string, string> = {
  government_id: 'Government-Issued Photo ID',
  ssn_documentation: 'SSN Documentation',
}

/** Human label for a stored document_type. Returns null for staff uploads (no type) or unknown values. */
export const documentTypeLabel = (raw: string | null | undefined): string | null => {
  if (!raw) {
    return null
  }
  return LABELS[raw] ?? null
}
